export default __webpack_public_path__ + "static/media/branche_placeholder.470dc5bc.svg";